import {Routes} from "react-router";
import {Navigate, Route} from "react-router-dom";
import Login from "@/auth/Login.jsx";
import Unauthorized from "@/auth/Unauthorized.jsx";
import ProtectedRoute from "@/auth/ProtectedRoute.jsx";
import DashboardLayout from "@/layout/DashboardLayout.jsx";
import Dashboard from "@/Dashboard.jsx";
import TokenExpirationWarning from "@/components/TokenExpirationWarning.jsx";
import TokenChecker from "@/components/TokenChecker.jsx";
import {useSelector} from "react-redux";

export const App = () => {
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  return (
      <TokenChecker>
          <Routes>
              {/* Redirection racine */}
              <Route
                  path="/"
                  element={
                      <Navigate
                          to={isAuthenticated ? "/dashboard" : "/login"}
                          replace
                      />
                  }
              />

              {/* Route publique */}
              <Route path="/login" element={<Login />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Routes protégées */}
              <Route element={<ProtectedRoute />}>
                  <Route element={<DashboardLayout />}>
                      <Route path="/dashboard" element={<Dashboard />} />
                      {/* Routes pour les sites */}
                      {/*<Route path="sites">*/}
                      {/*    <Route index element={<h1> Sites<h1/>} />*/}
                      {/*    /!*<Route path=":siteId" element={<SiteDetail />} />*!/*/}
                      {/*</Route>*/}


                      {/* Routes pour les visites */}
                      {/*<Route path="visites">*/}
                      {/*    <Route index element={<VisitorList />} />*/}
                      {/*    <Route path="analytics" element={<VisitorMap />} />*/}
                      {/*    <Route path="real-time" element={<RealTimeVisitors />} />*/}
                      {/*</Route>*/}
                      {/*<Route path="*" element={<NotFoundPage />} />*/}
                  </Route>
              </Route>

              {/* 404 pour les routes non protégées */}
              {/*<Route path="*" element={<Error404 />} />*/}
          </Routes>

          {/* Notification d'expiration de session */}
          <TokenExpirationWarning />
      </TokenChecker>
  )
};